import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import vuetify from './plugins/vuetify';
import Vuex from 'vuex';
import store from './store';
import {i18n} from './plugins/i18n';
import AxiosRequests from './AxiosRequests';
import Notifications from 'vue-notification';
import storageManager from '@/services/storageManager';
import localStoragePlugin from '@/plugins/localStoragePlug.js';

Vue.prototype.$axios = AxiosRequests;
Vue.prototype.$eventBus = new Vue();

const token = storageManager.getItem('token');
if (token) {
  store.state.token = token;
}

Vue.config.productionTip = false;
Vue.config.silent = false;

Vue.use(Vuex);
Vue.use(Notifications);
Vue.use(router);
Vue.use(localStoragePlugin);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
